//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileGuide(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 4.07L2 2.31V4.34L11 5.93V19.4L4 18.17V6.72L2 6.37V19.84L12 21.6L22 19.84V2.31L12 4.07ZM20 18.16L13 19.39V5.93L20 4.7V18.16Z" fill="currentColor" /><path d="M18.5 8.65002L14.5 9.35003V11.38L18.5 10.68V8.65002Z" fill="currentColor" /><path d="M18.5 12.71L14.5 13.41V15.44L18.5 14.74V12.71Z" fill="currentColor" /></svg>;
}
export default IconFileGuide;